import { render, staticRenderFns } from "./businessonebox-login.vue?vue&type=template&id=1043b0d2&"
import script from "./businessonebox-login.vue?vue&type=script&lang=js&"
export * from "./businessonebox-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports